export default {"src":"/_next/static/media/youtube.b4a2141b.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};